import React, { useEffect, useRef, useState } from 'react';
import html2canvas from 'html2canvas';
import DateComponent from './DateComponent';
import { Link, useSearchParams } from 'react-router-dom';

const CouponDownloader = (props) => {
    const path = process.env.REACT_APP_STATIC_CDN_ASSETS_IUIU

    const {box} = props
    const {rarityRating} = props
    const {stamp} = props
    const {signature} = props
    const {validity} = props
    const {revealRarity} = props
    const {revealEmoji} = props
    const {tryAgain} = props
    const {turns} = props
    const {nextTurn} = props
    const {addTurnsAndContinue} = props


    // 1. Create a ref to attach to the target DOM element
    const targetRef = useRef(null);

    const handleDownloadScreenshot = () => {
        // Ensure the ref is attached to an element
        if (!targetRef.current) {
            console.error("Target element not found.");
            return;
        }

        // 2. Pass the DOM element reference to html2canvas
        html2canvas(targetRef.current, {
            scale: 10, 
            useCORS: true 
        }).then(canvas => {
            
            // 3. Convert canvas to URL and trigger download
            const imageURL = canvas.toDataURL('image/png');
            const a = document.createElement('a');
            
            a.href = imageURL;
            const date = new Date();
            const h = date.getHours();
            const m = date.getMinutes();
            const s = date.getSeconds();
            const d = date.getDate();
            const M = date.getMonth()+1;
            const y = date.getFullYear();
            a.download = `${box.title}-${y}-${M}-${d}-${h}-${m}-${s}.png`;
            
            // Trigger the download
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            
        }).catch(error => {
            alert("Error generating screenshot:", error);
        });
    };

    useEffect(()=>{
        console.log("box", box)
    }, [box])

    return (
        <>{box && box.rarity && (<div style={{background: "orange", padding: "1rem", borderRadius: "1rem", boxShadow: "0 0 10px black"}}>
            {/* 4. Attach the ref to the specific div you want to capture */}
            {/* <div 
                ref={targetRef} 
                style={{ 
                    border: '2px solid #3c82f6', 
                    padding: '20px', 
                    backgroundColor: '#e0f2fe',
                    width: '300px'
                }}
            >
                <h3>Capture This Content</h3>
                <p>This dynamic content will be saved as an image file.</p>
                <p>Ref ID: {targetRef.current ? 'Attached' : 'Pending'}</p>
            </div> */}
            <div className='row center'>
                <h3>PHẦN THƯỞNG BỐC ĐƯỢC</h3>
            </div>
            {box && box.rarity && <div className='row center'>
                <div id="coupon" ref={targetRef} className={`blindboxBag interactiveText ${box.rarity.toLowerCase()}Bag`} for={box.title} style={{background: "#fff",  color: "red"}}>
                    <div>{box.emoji}</div>
                    {box.id && <div className='col'>
                        <div style={{marginLeft: "1rem"}}><b>{box.title}</b></div>
                        <div style={{marginLeft: "1rem", fontStyle: "italic", color: "#000"}}>Nhà tài trợ: {box.sponsor}</div>
                        <div style={{marginLeft: "1rem", fontStyle: "italic", color: "#000"}}>Người thụ hưởng: {box.receiver}</div>
                        <div style={{fontStyle: "italic"}}><img style={{width: "10rem"}} className='' src={path+"/"+box.image}></img></div>
                        <div className='row center' style={{fontSize: "2rem"}}>{rarityRating[box.rarity]}</div>
                        <div className={box.rarity.toLowerCase()+"Class class"}>{box.rarity}</div>
                        {box.attachment && box.attachment.length>0 && box.attachment.map(a=>
                        a.url ? <div className='row center attachment'
                            style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer'}}
                        ><Link className="" to={a.url} target="_blank" rel="noopener noreferrer"><div style={{fontSize: "1rem"}} title={a.title}><i class="fa fa-paperclip" aria-hidden="true"></i>{a.title.length>10 ? a.title.slice(0, 10)+"..." : a.title}</div></Link>
                        </div> :
                        a.function && <div className='row center attachment interactiveText'
                            style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer'}} onClick={()=>a.function && a.function==="revealRarity" ? revealRarity() : a.function==="tryAgain" ? tryAgain() : a.function==="revealEmoji" && revealEmoji()}
                        ><div style={{fontSize: "1rem"}} title={a.title}><i class="fa fa-paperclip" aria-hidden="true"></i>{a.title.length>10 ? a.title.slice(0, 10)+"..." : a.title}</div>
                        </div>
                        )}
                        {
                            box.attachment && box.attachment.length>0 && box.attachment && 
                            <div style={{fontStyle: "italic", color: "#000", fontSize: "0.7rem"}}>(*)Đối với vé kèm tệp đính kèm, vui lòng tải tệp riêng</div>
                        }                     
                        {
                            validity === "valid" ? 
                            <><div style={{fontStyle: "italic", color: "#000", fontSize: "0.7rem"}}>Hiệu lực từ <DateComponent passedDate={new Date()} lang="vi"></DateComponent></div>
                            <div style={{marginLeft: "1rem", fontStyle: "italic"}}><img className='stamp2' src={stamp}></img><img style={{width: "5rem"}} className='' src={signature}></img></div></>
                            : <div style={{fontStyle: "italic", color: "#000", fontSize: "0.7rem"}}>(*)Vé thử nghiệm không giá trị quy đổi</div>
                        }
                    </div>}
                </div>
            </div>}
            {turns && turns>0 ? <div className='row center iuiuButton' id="nextTurnButton"
                style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer'}}
            ><div style={{fontSize: "1rem"}} title="Số lượt chơi còn lại">Còn <i class="fa fa-hand" aria-hidden="true"></i>{turns} lượt chơi</div>
            </div> : ""}
            {box && box.rarity &&  <div className='attachment row center' 
                onClick={handleDownloadScreenshot}
                style={{ marginTop: '15px', padding: '10px 20px', cursor: 'pointer' }}
            >
                <i class="fa fa-download" aria-hidden="true"></i>TẢI VOUCHER
            </div>}
        </div>)}</>
    );
};

export default CouponDownloader;